import React, { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}

export const WorkDetailCard = ({ children }: Props): JSX.Element => (
    <div className="bg-white rounded-lg p-6 flex-grow">{children}</div>
);
